import { useEffect, useState } from "react";
import { useApiCall } from "./useApiCall";
import { useAuth } from "./useAuth";

export const useIsEmailAddressAvailable = () => {
  const { user } = useAuth();
  const { executeApiCall, apiCallResponse, apiCallStatus } = useApiCall();
  const [isEmailAddressAvailable, setIsEmailAddressAvailable] = useState(true);
  const [isEmailAddressAvailableError, setIsEmailAddressAvailableError] =
    useState("");
  const [isEmailAddressAvailableStatus, setIsEmailAddressAvailableStatus] =
    useState("idle");

  const checkEmailAddressAvailability = (email) => {
    if (user && user.email === email.toLowerCase()) {
      setIsEmailAddressAvailable(true);
      setIsEmailAddressAvailableStatus("ready");
      setIsEmailAddressAvailableError();

      return;
    }

    const requestOptions = {
      url: `/auth/is-available`,
      method: "POST",
      data: {
        email,
      },
    };

    executeApiCall(requestOptions);

    setIsEmailAddressAvailableStatus("pending");
    setIsEmailAddressAvailableError();
  };

  useEffect(() => {
    switch (apiCallStatus) {
      case "success":
        if (apiCallResponse?.data?.data) {
          const { isAvailable } = apiCallResponse?.data?.data;

          setIsEmailAddressAvailable(isAvailable);
          setIsEmailAddressAvailableStatus("ready");
        } else {
          setIsEmailAddressAvailableError(
            apiCallResponse?.data?.error?.userMessage
          );
          setIsEmailAddressAvailableStatus("ready");
        }
        break;
      case "error":
        setIsEmailAddressAvailableStatus("ready");
    }
  }, [apiCallResponse, apiCallStatus]);

  return {
    checkEmailAddressAvailability,
    isEmailAddressAvailableError,
    isEmailAddressAvailableStatus,
    isEmailAddressAvailable,
  };
};
